module.exports = __webpack_public_path__ + "img/plate_3.f264a1b2.png";